import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { styleguideConfig } from '../../config/styleguide-config';
import { Store } from '@ngrx/store';
import { getAllThemes } from 'src/app/themes/store';
import { Theme } from 'src/app/themes/models';
import { PaletteCardComponent } from '../../components/palette-card/palette-card.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ColorListComponent } from '../../components/color-list/color-list.component';

@Component({
  selector: 'app-colors',
  templateUrl: './colors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaletteCardComponent, NgClass, ColorListComponent, AsyncPipe],
})
export class ColorsComponent {
  private store = inject(Store);
  themes$ = this.store.select(getAllThemes);
  themeColors = styleguideConfig.bsStyles;
  colors = ['blue', 'indigo', 'purple', 'pink', 'red', 'orange', 'yellow', 'green', 'teal', 'cyan'];
  grayColors = ['900', '800', '700', '600', '500', '400', '300', '200', '100'];

  activeGrayColors = [];

  palettes = styleguideConfig.themePalettes;

  constructor() {}

  remainingColors(fullList: string[], newList: string[]) {
    return fullList.filter(color => !newList.includes(color));
  }

  getColorByKey(theme: Theme, key: string) {
    return (theme as unknown as { [key: string]: string })[key];
  }

  camelToDashed(camel: string) {
    return camel.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
  }
}
